export enum FetchingOptions {
  FETCH_SEARCH = 'FETCH_SEARCH',
  ON_CREATE = 'ON_CREATE',
  ON_LIST_SEGMENTED_ZONES = 'ON_LIST_SEGMENTED_ZONES',
  ON_UPDATE_SEGMENTED_ZONES = 'ON_UPDATE_SEGMENTED_ZONES',
}
